import { Injectable } from '@angular/core';
//import { LoadingController } from 'ionic-angular';
//import { UserData } from '../../../../providers/user-data'; 
import { PageRef } from '../../../../core/core.module';
import firebase from 'firebase';
//import { LoginPage } from '../login/login';

@Injectable()
export class OrderHistoryCommon {
	public realtimeDb: any;
	//public currentUser: any;
	//public nameInitials: string;
	constructor(
		//public userData: UserData,
    	public pageRef: PageRef,
		//public loadingCtrl: LoadingController,
	) {
		this.realtimeDb = firebase.database();
	}

	public commonMethod(){
		console.log("Hello Order History Page");
	}

}



// WEBPACK FOOTER //
// ./src/modules/account/pages/order-history/order-history.common.ts